export const tooltipMaker = (title = '') => ({
    title
});
